import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FellowForm from '../../../components/forms/FellowForm';
import { useFellowById, useUpdateFellow } from '../../../hooks/useFellowApi';
import { useNavigate, useParams } from 'react-router-dom';

const FellowEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFellowById(id!);
  const updateFellow = useUpdateFellow();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Fellows', href: '/admin/fellows' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateFellow.mutateAsync({ id: id!, data });
      navigate('/admin/fellows');
    } catch (error) {
      console.error('Error updating Fellow:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/fellows"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Fellow.Edit'
    >
      {entityData ? (
        <FellowForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/fellows')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default FellowEdit;
